enum ZoneControllerMouseState {
  Default = "Default",
  AddCleaningZone = "AddCleaningZone",
  AddTeachAndRepeatZone = "AddTeachAndRepeatZone",
  AddRedZone = "AddRedZone",
  AddRedZoneLine = "AddRedZoneLine",
  AddRuleZone = "AddRuleZone",
  AddLandmarkPoint = "AddLandmarkPoint",
  AddGate = "AddGate",
  DeleteZone = "DeleteZone",
  DeletePoint = "DeletePoint",
  DragZone = "DragZone",
  CopyZone = "CopyZone",
  AddWayPoint = "AddWayPoint",
  ShowDetails = "ShowDetails",
  SendToBack = "SendToBack",
  CropMap = "CropMap",
  AddEvacuationPlace = "AddEvacuationPlace",
  DrawRectangleTool = "DrawRectangleTool",
  DrawPenTool = "DrawPenTool",
  DrawLineTool = "DrawLineTool",
  EditRoomLimitation = "EditRoomLimitation",
  DragRoomLimitationZone = "DragRoomLimitationZone",
  DeleteRoomLimitationZonePoint = "DeleteRoomLimitationZonePoint",
}

export default ZoneControllerMouseState;

export const isAddingState = (mouseState: ZoneControllerMouseState) => {
  return (
    mouseState === ZoneControllerMouseState.AddCleaningZone ||
    mouseState === ZoneControllerMouseState.AddTeachAndRepeatZone ||
    mouseState === ZoneControllerMouseState.AddRedZone ||
    mouseState === ZoneControllerMouseState.AddRedZoneLine ||
    mouseState === ZoneControllerMouseState.AddRuleZone
  );
};
